<div class="component-loader-circle"></div>
<div class="component-loader-line-mask">
  <div class="component-loader-line"></div>
</div>
